import React from 'react';
import Layout from '../../desktop/Layout';
import StorePickup from './index';

const DesktopStorePickup = props => {
  return (
    <Layout header>
      <StorePickup {...props} />
    </Layout>
  );
};

export default DesktopStorePickup;
